import { render, staticRenderFns } from "./SurgeryDetailPage.vue?vue&type=template&id=299f9cda&"
import script from "./SurgeryDetailPage.vue?vue&type=script&lang=js&"
export * from "./SurgeryDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports